export const SectionHeader = ({ title, index, icon: Icon }) => (
  <div className="flex items-center justify-between gap-3 pl-4 pr-4 mb-8 border-b border-gray-200 pb-4 sticky top-0 bg-white/80 backdrop-blur-md z-10 pt-4 rounded-md">
    <div className="flex items-center gap-3">
      <div className="p-2 bg-ink text-white rounded-md">
        <Icon size={16} />
      </div>
      <h2 className="text-2xl font-ndot text-ink tracking-tight select-none">{title}</h2>
    </div>
    {index != null && (
      <span className="font-ndot text-sm text-gray-300 select-none">{String(index).padStart(2, "0")}</span>
    )}
  </div>
);